import { Navigate, useSearchParams } from 'react-router-dom';

import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { searchFacetsAll } from 'modules/search/constants/searchFacetsAll';
import { isSearchType } from 'modules/search/helpers/isSearchType';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';
import { searchGetRoutePathSwitch } from 'modules/search/routing/helpers/searchGetRoutePathSwitch';

export function SearchAllPage() {
  const [searchParams] = useSearchParams();

  const listingTypeQueryParam = searchParams.get('listing-type');
  const query = searchParams.get('q');

  useSetDocumentTitle(
    /* TRANSLATORS: everything search page title */
    getText('Jobs, Volunteering, Grad Schools, and More'),
  );

  if (listingTypeQueryParam && isSearchType(listingTypeQueryParam)) {
    return (
      <Navigate
        to={searchGetRoutePathSwitch({
          lang: CURRENT_LOCALE,
          q: query || undefined,
          filtersByName: { type: listingTypeQueryParam },
        })}
      />
    );
  }

  return (
    <SearchPage
      searchType="ALL"
      searchFacets={searchFacetsAll}
      allowAds={false}
    />
  );
}
